  import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
  import { Navigate, useNavigate } from "react-router-dom";

export const ProtectedRoute = ({ children, roles = [] }) => {
  const { checkAuth, isAuthenticated, isAuthChecked, user } = useAuth();
  const navigate = useNavigate();

  useEffect(()=> {
    if (isAuthChecked) {
      if (!isAuthenticated && !user) {
        navigate("/login")
      } else if (roles.length > 0 && !roles.includes(user?.role)) {
        navigate("/unauthorized")
      }
    }
  },[isAuthChecked, isAuthenticated, user, roles, navigate])

  if (!isAuthChecked) {
    return null; // or a loading spinner
  }

  return children;
};
